import type { ApiErrorInfo } from './api';

export function isApiUnavailableError(error: ApiErrorInfo): boolean {
  if (error.kind === 'network' || error.kind === 'cors') {
    return true;
  }
  if (error.kind === 'http' && typeof error.status === 'number' && error.status >= 500) {
    return true;
  }
  const msg = (error.message || '').toLowerCase();
  if (msg.includes('failed to fetch') || msg.includes('network request failed')) {
    return true;
  }
  return false;
}
